import { myAxios } from "../../utils/serverContextPath";

export const getWilayaById = (id) => {
  return myAxios.get(`wilaya/getbyid/${id}`);
};

export const getWilayaAllPage = (
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("wilaya/getallpage", {
    params: {
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const getAllWilaya = (
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("wilaya/getall", {
    params: {
      keyword,
      sortList,
      sortOrder,
    },
  });
};

export const deleteWilaya = (id) => {
  return myAxios.delete(`wilaya/delete/${id}`);
};

export const postWilaya = (data) => {
  return myAxios.post("wilaya/save/insert", data);
};

export const updateWilaya = (data) => {
  return myAxios.post("wilaya/save/Update", data);
};
